import I18n from '../config/i18n';

export const modelName = (model) => I18n.t(`models.${model}`);
export const modelPluralName = (model) => I18n.t(`models.${model}`, { count: 100 });
export const attributeName = (model, attr, options) => I18n.t(`attributes.${model}.${attr}`, options);
